import { ThemeColors } from '.'

export interface DefaultColors {
  FontColor: {
    Default: ThemeColors
    Link: ThemeColors
    Error: ThemeColors
    Placeholder: ThemeColors
    Highlight: ThemeColors
  }
  Switch: {
    Background: {
      Default: ThemeColors
      Disabled: ThemeColors
      Toggled: ThemeColors
    }
    Border: ThemeColors
    Thumb: {
      Default: ThemeColors
      Disabled: ThemeColors
      Focus: ThemeColors
    }
  }
  Button: {
    FocusVisible: {
      BoxShadow: ThemeColors
    }
  }
  Icon: ThemeColors
  SeparatorBorder: ThemeColors
  Input: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Focus: ThemeColors
      Active: ThemeColors
      Disabled: ThemeColors
    }
    Border: {
      Default: ThemeColors
      Hover: ThemeColors
      Focus: ThemeColors
      Disabled: ThemeColors
      Error: ThemeColors
    }
    FontColor: {
      Disabled: ThemeColors
    }
    BoxShadow: {
      Focus: ThemeColors
    }
  }
  Background: {
    PrimaryNav: {
      Default: ThemeColors
      Hover: ThemeColors
      Selected: ThemeColors
    }
    SecondaryNav: {
      Default: ThemeColors
      Hover: ThemeColors
      Selected: ThemeColors
    }
    Page: ThemeColors
    DataContainer: ThemeColors
    Tooltip: ThemeColors
    Button: {
      Default: ThemeColors
      Hover: ThemeColors
    }
  }
  BoxShadow: ThemeColors
  ModalOverlay: ThemeColors
}

export const defaultColors: DefaultColors = {
  FontColor: {
    Default: {
      default: 'gray.1300',
    },
    Link: {
      default: 'mango.blue',
    },
    Error: {
      default: 'red.500',
    },
    Placeholder: {
      default: 'gray.600',
    },
    Highlight: {
      default: 'mango.highlight',
    },
  },
  Switch: {
    Background: {
      Default: {
        default: 'gray.500',
      },
      Disabled: {
        default: 'gray.300',
      },
      Toggled: {
        default: 'green.700',
      },
    },
    Border: {
      default: 'achromatic.transparent',
    },
    Thumb: {
      Default: {
        default: 'white',
      },
      Disabled: {
        default: 'gray.200',
      },
      Focus: {
        default: 'blue.700',
      },
    },
  },
  SeparatorBorder: {
    default: 'gray.400',
  },
  Icon: {
    default: 'gray.1300',
  },
  Input: {
    Background: {
      Default: {
        default: 'gray.100',
      },
      Hover: {
        default: 'white',
      },
      Focus: {
        default: 'white',
      },
      Active: {
        default: 'white',
      },
      Disabled: {
        default: 'gray.300',
      },
    },
    Border: {
      Default: {
        default: 'gray.600',
      },
      Hover: {
        default: 'gray.800',
      },
      Focus: {
        default: 'blue.700',
      },
      Disabled: {
        default: 'gray.500',
      },
      Error: {
        default: 'red.700',
      },
    },
    BoxShadow: {
      Focus: {
        default: 'mask.blue.700.20',
      },
    },
    FontColor: {
      Disabled: {
        default: 'gray.500',
      },
    },
  },
  Background: {
    PrimaryNav: {
      Default: {
        default: 'gray.100',
      },
      Hover: {
        default: 'gray.300',
      },
      Selected: {
        default: 'gray.400',
      },
    },
    SecondaryNav: {
      Default: {
        default: 'gray.200',
      },
      Hover: {
        default: 'gray.400',
      },
      Selected: {
        default: 'gray.400',
      },
    },
    Page: {
      default: 'gray.300',
    },
    DataContainer: {
      default: 'gray.100',
    },
    Tooltip: {
      default: 'gray.1300',
    },
    Button: {
      Default: { default: 'mango.blue' },
      Hover: { default: 'blue.1100' },
    },
  },
  BoxShadow: {
    default: 'mask.gray.1300.20',
  },
  Button: {
    FocusVisible: {
      BoxShadow: {
        default: 'mask.blue.800.50',
      },
    },
  },
  ModalOverlay: {
    default: 'mask.gray.1300.40',
  },
}
